import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import Cookies from 'js-cookie';

const getPreAuthTokenFromCookie = () => Cookies.get('pre_auth_token') || '';

const OtpFormSchema = z.object({
  otp: z.string().min(6, 'Please enter a valid 6-digit code.'),
  preAuthToken: z.string().min(1, 'Token is required.'),
});

export type OtpForm = z.infer<typeof OtpFormSchema>;

export const otpFormDefaultValues: OtpForm = {
  otp: '',
  preAuthToken: getPreAuthTokenFromCookie(),
};

export const useOtpForm = () => {
  const form = useForm<OtpForm>({
    resolver: zodResolver(OtpFormSchema),
    defaultValues: otpFormDefaultValues,
  });

  return form;
};
